import { OrderStatus, OrderStatusData, OrderDetailData } from '../../pages/order/order_status/request/interface';
import { ORDER_STATUS_SOURCE } from '../OrderCommon/constant';

const OrderSuccessToken = 'u3483h';
const FirstOrderToken = 'cs98wd';
const ViewRestaurantToken = 'sd3biz';
const AddGoodsToCardToken = 'cghd0m';
const DeleteGoodsToken = 'uvhpy5';

const First_Order_Flag = 'first_order_flag';

const SLADJustHandler = Mach.requireModule('SLADJust');

let SLADCurrentOrderId = '';

export default class AdjustUtils {
  static AdjustTrackEvent = (token: string) => {
    console.log(` SLADJustHandler is token ${token}`);
    SLADJustHandler?.trackEvent(token || '');
  }
  static AdjustTrackRevenueEvent = (token: string, currency: string, revenue: string) => {
    SLADJustHandler?.trackRevenueEvent(token || '', currency || '', revenue);
  }

  static OrderSuccessTrack = (orderStatus: OrderStatusData|undefined, orderDetail: OrderDetailData|undefined) => {
    if (Mach.env.schemeParams?.source === ORDER_STATUS_SOURCE.CONFIRM) {
      if ((orderStatus?.orderOperateInfo?.orderStatusInfo?.orderStatus || 0) >= OrderStatus.PAYED
      && (orderStatus?.orderOperateInfo?.orderStatusInfo?.orderStatus || 0) <= OrderStatus.FETCH) {
        if (orderDetail?.orderInfo && orderDetail.orderInfo?.payPrice) {
          if (orderDetail.orderBaseInfo.orderViewId !== SLADCurrentOrderId) {
            SLADCurrentOrderId = orderDetail.orderBaseInfo.orderViewId;
            AdjustUtils.AdjustTrackRevenueEvent(OrderSuccessToken, orderDetail.orderInfo.payPrice.currency || '', orderDetail.orderInfo.payPrice.displayAmount);
            const Storage = Mach.requireModule('Storage');
            console.log('---------AdjustTrackRevenueEvent----------');
            const value = Storage?.getString({ channel: 'market', key: First_Order_Flag });
            if (value == undefined || value !== 'false') {
              Storage?.setString({ channel: 'market', key: First_Order_Flag, value: 'false' });
              console.log('---------FirstOrderToken----------');
              AdjustUtils.AdjustTrackRevenueEvent(FirstOrderToken, orderDetail.orderInfo.payPrice.currency || '', orderDetail.orderInfo.payPrice.displayAmount);
            }
          }
        }
      }
    }
  }
  static ViewRestaurantTrack = () => {
    AdjustUtils.AdjustTrackEvent(ViewRestaurantToken);
  }

  static AddGoodsToCardTrack = () => {
    AdjustUtils.AdjustTrackEvent(AddGoodsToCardToken);
  }

  static DeleteGoodsTrack = () => {
    AdjustUtils.AdjustTrackEvent(DeleteGoodsToken);
  }
}
